module.exports = __webpack_public_path__ + "static/media/DD.96d61b69.png";